module.exports = __webpack_public_path__ + "img/2b54058f706348cb8a276317f38b74c7-640.4fef7dd4.png";